import { render } from "./overall-usage.vue?vue&type=template&id=1b7f5946"
import script from "./overall-usage.vue?vue&type=script&lang=js"
export * from "./overall-usage.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/PRD_sharetreats_v1_hr_company_dashboard_client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__